import EssentialOption from './essential-option';
import AbstractGroup from './abstract-group';
import EssentialGroupData from './types/essential-group-data';
import A11yConsentApi from './a11y-consent-api';
import Logger from './utilities/logger';

/**
 * Essential consent group, meaning it contains only consent options, that cannot be enabled or disabled by the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export default class EssentialGroup extends AbstractGroup {
  public options: { [p: string]: EssentialOption } = {};

  constructor(api: A11yConsentApi, data: EssentialGroupData) {
    super(api, data);
    Logger.debug('essential-group', `Starting to construct "${this.uid}".`);

    for (const identifier in data.options) {
      this.options[identifier] = new EssentialOption(this.api, this, data.options[identifier]);
    }

    Logger.debug('essential-group', `Finished constructing "${this.uid}".`);
  }
}
